import * as React from 'react';
import { Row, Col, Button } from 'antd';
import { CenterAlignRow } from 'components/Styled/Layout.Styled';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { AppRoutes } from 'Core/AppRoutes';
import AppRoute from 'Core/models/AppRoute';
import { matchPath } from 'react-router';
import Utility from 'Core/Utility';
import BlankCenteredLogoLayout from 'components/Layout/BlankCenteredLogoLayout';

export interface Props extends RouteComponentProps {
  children?: React.ReactNode;
}

export interface State {
    shouldNotRender: boolean;
}

export class NotFoundViewWithoutRouter extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {shouldNotRender: false};
    this.handleHome = this.handleHome.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.isMatch = this.isMatch.bind(this);
    this.checkIfPageShouldRender = this.checkIfPageShouldRender.bind(this);
  }

  componentDidMount() {
    this.checkIfPageShouldRender();
  }

  checkIfPageShouldRender(){
    const appRoutesWithout404 = AppRoutes.filter(x=> x.path != "/*");
    const shouldNotRender = Utility.getAppRoutesWithFullPath(appRoutesWithout404)?.some(x=> this.isMatch(x)) ?? false;
    this.setState({shouldNotRender: shouldNotRender});
  }

  componentDidUpdate(nextProps) {
    if (nextProps.location !== this.props.location) {
        this.checkIfPageShouldRender();
    }
  }

  isMatch(route: AppRoute): boolean {
    return !!matchPath(this.props.location.pathname, route) ||  (route.routes?.some(x=> this.isMatch(x)) ?? false);
  }

  handleHome(e: React.FormEvent) {
    e.preventDefault();
    this.props.history.push('/Home');
  }

  handleLogin(e: React.FormEvent) {
    e.preventDefault();
    this.props.history.push('/login');
  }

  render() {
    return (
    !this.state.shouldNotRender &&
    <BlankCenteredLogoLayout>
    <Row type="flex" justify="center" style={{ height: '57vh', marginTop: '150px' }}>
        <Col xs={{ span: 24 }} lg={{ span: 24 }}>
          <Row>
            <Col>
              <Row
                style={{
                  left: '50%',
                  top: '50%',
                  transform: `translate(-50%,-50%)`,
                  lineHeight: 1.4,
                  paddingLeft: '15px',
                  paddingRight: '15px',
                }}>
                <Row
                  style={{
                    top: 0,
                    left: '50%',
                    zIndex: -2,
                    transform: `translate(-30%,-30%)`,
                    height: '100px',
                  }}>
                  <h1
                    style={{
                      transform: `translate(-50 %, -50 %)`,
                      fontSize: '270px',
                      top: '50%',
                      left: '50%',
                      margin: 0,
                      color: '#ececec',
                      fontWeight: 900,
                      fontFamily: 'maven pro,sans-serif',
                    }}>
                    404
                  </h1>
                </Row>
                <CenterAlignRow>
                  <Col>
                    <h2 style={{ margin: 0, fontWeight: 900 }}>WE ARE SORRY, PAGE NOT FOUND</h2>
                  </Col>
                </CenterAlignRow>
                <CenterAlignRow>
                  <Col>
                    <p
                      style={{
                        fontFamily: 'maven pro,sans-serif',
                        marginTop: '10px',
                        fontWeight: 400,
                        fontSize: '16px',
                      }}>
                      THE PAGE YOU ARE LOOKING FOR MIGHT HAVE BEEN REMOVED, HAD ITS NAME CHANGED OR
                      IS TEMPORARILY UNAVAILABLE.
                    </p>
                  </Col>
                </CenterAlignRow>
                <CenterAlignRow>
                  <Col>
                    <Button onClick={this.handleHome} size="large" shape="round" type="primary">
                      {' '}
                      Back to HomePage
                    </Button>
                  </Col>
                </CenterAlignRow>
                <CenterAlignRow style={{ marginTop: '15px' }}>
                  <Col>
                    <Button onClick={this.handleLogin} size="large" shape="round" type="default">
                      {' '}
                      Login
                    </Button>
                  </Col>
                </CenterAlignRow>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      </BlankCenteredLogoLayout>  
    );
  }
}

const NotFoundView = withRouter(NotFoundViewWithoutRouter);
export default NotFoundView;
